import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ExportPDF = ({ tableId, filename = "report.pdf" }) => {
  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape", // or "portrait"
      unit: "pt",
      format: "a4",
    });

    // Call autoTable correctly
    autoTable(doc, {
      html: `#${tableId}`,
      useCss: true,
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 4 },
      headStyles: { fillColor: [22, 160, 133] },
    });

    doc.save(filename);
  };

  return (
    <button onClick={downloadPDF} id="PDF">
      Export PDF
    </button>
  );
};

export default ExportPDF;
